"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { ARCHIVES_FAQ } from "@/data/archivesData";
const ArchivesAbout = () => {
  const $ = _c(6);
  const [openIndex, setOpenIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A] font-light">About Girmitiya</span><div className="w-8 h-px bg-[#DF6D2A]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-center mb-10 sm:mb-14 flex flex-col items-center">{t0}<h2 className="font-display text-[34px] sm:text-[44px] md:text-[52px] font-light leading-[1.05] tracking-[-0.02em] text-[#0F1C2E]">Understanding the <em className="text-[#C9A84C] italic">Legacy</em></h2></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== openIndex) {
    t2 = ARCHIVES_FAQ.map((faq, index) => {
      const isOpen = openIndex === index;
      return <div key={faq.id} className="border-b border-[#0F1C2E]/15"><button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-start sm:items-center justify-between py-5 sm:py-6 md:py-7 text-left group gap-4"><div className="flex items-start sm:items-center gap-4 sm:gap-5 min-w-0"><span className="font-display text-[18px] sm:text-[22px] text-[#DF6D2A] shrink-0 leading-none pt-0.5 sm:pt-0">{faq.id}</span><h3 className={`font-display text-[18px] sm:text-[22px] md:text-[26px] font-light tracking-tight transition-colors duration-300 ${isOpen ? "text-[#DF6D2A]" : "text-[#0F1C2E] group-hover:text-[#DF6D2A]"}`}>{faq.question}</h3></div><div className={`ml-auto w-8 h-8 sm:w-10 sm:h-10 rounded-full border flex-shrink-0 flex items-center justify-center transition-colors duration-300 ${isOpen ? "border-accent-cta bg-accent-cta text-white" : "border-[#0F1C2E]/20 text-[#0F1C2E] group-hover:border-[#DF6D2A] group-hover:text-[#DF6D2A]"}`}>{isOpen ? <Minus size={16} strokeWidth={1.5} /> : <Plus size={16} strokeWidth={1.5} />}</div></button><AnimatePresence>{isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.4,
            ease: "easeOut"
          }} className="overflow-hidden"><p className="font-body text-[14px] sm:text-[16px] font-light text-[#4C596B] leading-[1.75] pb-6 sm:pb-8 max-w-[850px] pl-0 sm:pl-[52px] pr-4 sm:pr-8">{faq.answer}</p></motion.div>}</AnimatePresence></div>;
    });
    $[2] = openIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <section className="bg-[#F4EFE6] py-16 sm:py-24 md:py-28 relative border-b border-[#0F1C2E]/10"><div className="max-w-[1000px] mx-auto px-4 sm:px-6 md:px-8 relative z-10">{t1}<div className="flex flex-col border-t border-[#0F1C2E]/15">{t2}</div></div></section>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ArchivesAbout;